<template>
    <div class="bloque-general bloque-reporta">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="bloque-general__encabezado">
                        <h2>Reporta</h2>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-4 col-lg-4">
                    <div class="item-contacto">
                        <a href="tel:911" class="link-telefono">911</a>
                        <a href="tel:911" class="link-contacto">Emergencias</a>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4">
                    <div class="item-contacto">
                        <a href="tel:8122851112" class="link-telefono">81 2285 1112</a>
                        <a href="tel:8122851112" class="link-contacto">Protección civil</a>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4">
                    <div class="item-contacto">
                        <a href="tel:8110308541" class="link-telefono">81 1030 8541</a>
                        <a href="tel:8110308541" class="link-contacto">Defensoría Emergencia</a>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mt-4">
                <div class="col-md-6 col-lg-4">
                    <div class="item-contacto">
                        <a href="tel:8188811111" class="link-telefono">81 8881 1111</a>
                        <a href="tel:8188811111" class="link-contacto">Línea Rosa</a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="item-contacto">
                        <a href="tel:8120027848" class="link-telefono">81 2002 7848</a>
                        <a href="tel:8120027848" class="link-contacto">C4</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
